export const CREATING_COMMENT = "CREATING_COMMENT";
export const UPDATING_COMMENT = "UPDATING_COMMENT";
export const COMMENT_CREATED = "COMMENT_CREATED";
export const COMMENT_UPDATED = "COMMENT_UPDATED";
export const ERROR_COMMENT_CREATE = "ERROR_COMMENT_CREATE";
export const ERROR_COMMENT_UPDATE = "ERROR_COMMENT_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
